<template>
  <div
    v-if="loaded"
    v-tooltip="{
      autoHide: false,
      triggers: ['hover', 'click', 'focus'],
      content: message,
      placement: placement,
      delay: {
        show: showDelay,
        hide: hideDelay
      },
      popperClass: classes
    }"
    class="tooltip-component-container"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
    showDelay: {
      type: Number,
      default: 0,
    },
    hideDelay: {
      type: Number,
      default: 0,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  created() {
    this.loaded = true;
  },
};
</script>

<style lang='scss'>
  .tooltip-component-container {
    cursor: pointer;
    display: inline-block;
  }

  .tooltip {
    display: block !important;
    max-width: rem-calc(300);
    z-index: 10000;

    @include breakpoint(small) {
      max-width: rem-calc(250);
    }

    .tooltip-inner {
      background: #354052;
      color: white;
      padding: 10px 16px 14px;

      a {
        color: white !important;
        font-weight: 600;
        text-decoration: underline;
      }
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: #354052;
      z-index: 1;
    }

    &[x-placement^="top"] {
      // margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      &.bookmark-tooltip {
        margin-right: 10px;
      }

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }

    &.bookmark-tooltip {
      font-size: rem-calc(12);
    }

    &.phone-tooltip {
      margin-left: rem-calc(12);
      font-size: rem-calc(12);
      line-height: 1.22;
    }
  }
</style>
